<template>
    <el-card class="card-main">
       <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
        <el-form-item>
          <el-select v-model="searchInfo.projectId" placeholder="请选择项目" filterable clearable>
            <el-option
              v-for="item in projectList"
              :key="item.projectId"
              :label="item.projectName"
              :value="item.projectId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-input v-model="searchInfo.teamName" clearable placeholder="请输入班组名称"/>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="searchInfo.createTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择纠偏时间">
          </el-date-picker>
      </el-form-item>
        <el-form-item>
          <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- <div>
        <el-button class="mb20" type="primary" @click="onExport" v-show="$ButtonShow('YWK_SEL_10')">
          <div class="importExport">
            <svg class="global-icon" aria-hidden="true">
              <use :xlink:href="'#icon-icon_obj_daochu'"></use>
            </svg>
            <span>导出</span>
          </div>
        </el-button>
      </div> -->
      <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData">
        <el-table-column label="班组名称" min-width="100px" show-overflow-tooltip prop="teamName">
        </el-table-column>
        <el-table-column label="项目名称" min-width="100px" show-overflow-tooltip prop="projectName">
        </el-table-column>
        <el-table-column label="签到时间" min-width="100px" show-overflow-tooltip prop="signTime">
        </el-table-column>
        <el-table-column label="识别人数" min-width="100px" show-overflow-tooltip prop="systemIdentifyNum">
          <template v-slot="{row}">
            {{ row.systemIdentifyNum ? row.systemIdentifyNum : 0 }}
          </template>
        </el-table-column>
        <el-table-column label="修正人数" min-width="100px" show-overflow-tooltip prop="modifyNum">
        </el-table-column>
        <el-table-column label="纠偏人" min-width="100px" show-overflow-tooltip prop="createUserName">
        </el-table-column>
        <el-table-column label="纠偏时间" min-width="100px" show-overflow-tooltip prop="createTime">
        </el-table-column>
        <el-table-column label="操作" width="180px" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="onDetail(row.modifyId)" >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <global-pagination
        :total="total"
        :current-page.sync="page"
        :page-size.sync="size"
        @current-change="loadData"
        @size-change="loadData"
      ></global-pagination>
      <Details :detailsShow.sync="detailsShow"  :id.sync = id></Details>
    </el-card>
</template>

<script>
import Details from './CorrectListDetails.vue'

// @KeepAlive
export default {
  name: 'CorrectList',
  components: {
    Details
  },
  data () {
    return {
      searchInfo: {
        projectId: '',
        createTime: '',
        teamName: ''
      },

      total: 0,
      page: 1,
      size: 10,
      loading: false,
      tableData: [],

      id: '',
      detailsShow: false
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    }

  },

  created () {
    this.loadData()
  },
  methods: {
    loadData () {
    // console.log('loadData')
      this.loading = true
      this.$axios.get(this.$apis.laborManage.selectYhTeamSignModifyLogByPage,
        {
          ...this.searchInfo,
          page: this.page,
          size: this.size
        }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch () {
      this.page = 1
      this.loadData()
    },

    onExport () {
      const loading = this.$loading({
        lock: true,
        text: '下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$axios.downloadFile(this.$apis.recruitUse.exportWorkerDutyCount, this.searchInfo).finally(() => {
        loading.close()
      })
    },

    onDetail (id) {
      this.id = id
      this.detailsShow = true
    }
  }

}
</script>

<style scoped lang="scss">
   ::v-deep .card-main {
  padding: 0 !important;
  }
  ::v-deep .el-card__body {
    padding: 20px 40px !important;
  }
  .main {
    width: 100%;
    padding: 20px 40px;
    border-top: 1px solid #F4F4F4;
  }
</style>
